export enum TourTypeEnum {
  Welcome = 1,
  News = 2,
}
